module.exports = __webpack_public_path__ + "static/media/cup.3f751f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cup.png
// module id = 174
// module chunks = 0